import Vue from 'vue'
import App from './App.vue'
import router from './router'
import msal from 'vue-msal'
import axios from 'axios'
import Notifications from 'vue-notification'
import moment from 'moment'
import _ from 'lodash'
import vSelect from 'vue-select'
import BootstrapVue from 'bootstrap-vue'
import Vue2Filters from 'vue2-filters'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPaperclip, faTrash, faEdit, faInfoCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faStickyNote } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './custom.scss'
import SETTINGS from './settings'

Vue.config.productionTip = false;
Vue.prototype.$hostname = SETTINGS.APIURL;
Vue.prototype.$roles = SETTINGS.ROLES;
Vue.config.silent = true;

const base = axios.create({
    baseURL: Vue.prototype.$hostname,
})


//global vue
Vue.prototype.$http = base
Vue.prototype._ = _;
Vue.prototype.moment = moment

Vue.filter('formatDate', function (value) {
    if (value) {
        if(moment.isMoment(value))
            return value.format('MM/DD/YYYY')
        else 
            return moment.utc(String(value)).format('MM/DD/YYYY');
    }
});

Vue.filter('formatDatetime', function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY h:mm:ss a')
    }
});

Vue.filter('yesno', function (value) {
    if (value) {
        return 'Yes';
    }

    return 'No';
});

Vue.filter('snapshotChangeType', function (value) {
    if (value) {
        let response = ''
        switch (value) {
            case 1:
                response = 'None';
                break;
            case 2:
                response = 'Add';
                break;
            case 3:
                response = "Edit";
                break;
            case 4:
                response = 'Delete'
                break;
            default:
                response = '';
                break;
        }

        return response;
    }
});


Vue.prototype.$traveExpenseReportTotals = {
    airfareReimbursementAmount: null,
    carRentalReimbursementAmount: null,
    groundTransportationReimbursementAmount: null,
    lodgingReimbursementAmount: null,
    mealReimbursementAmount: null,
    miscCostReimbursementAmount: null,
    personalVehicleMileageReimbursementAmount: null,
    otherCombinedCostReimbursementAmount: null,
    totalReimbursementAmount: null
}

library.add(faPaperclip, faTrash, faEdit, faInfoCircle, faStickyNote, faExclamationTriangle)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', vSelect)

Vue.use(Vue2Filters)
Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(msal, {
    auth: {
        clientId: "15410c8d-0b96-48f2-a0d4-4132034ba881",
        tenantId: "09a96d2f-68a1-46da-beec-ff57669fc6b8",
        requireAuthOnInitialize: true,
        redirectUri: window.location.origin
    },
    request: {
        scopes: ["api://15410c8d-0b96-48f2-a0d4-4132034ba881/api_test"]
    },
    framework: {
        globalMixin: true
    }
});



var vm = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

//global used to expose msal token to root api service for headers
window.$msal = vm.msal;
